export default "__VITE_ASSET__5a9f98e5__"